import React, { useState } from "react";
import { Row, Col, Card } from "antd";
import { MainHeading, PricingPageWrapper, SubHeading } from "./styled";
import { SubscriptionData } from "./Subscription";
import { FaCheck } from "react-icons/fa6";
import { CustomButton } from "../physician_page/styled";
import SubscribeSuccessfulModal from "./SubscribeSuccessfulModal";
import Navbar from "../home/Navbar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const PricingPage = () => {
  const [subscription, setSubscription] = useState(SubscriptionData?.plans);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();

  return (
    <>
      <Navbar/>
      {isModalOpen && (
        <SubscribeSuccessfulModal
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
        />
      )}
      <PricingPageWrapper>
        <Row className="w-100 d-flex justify-content-center font-bold">
          <MainHeading>
            Subscription Plans for Healthcare Professionals
          </MainHeading>
        </Row>
        <Row className="w-100 d-flex justify-content-center font-medium mb-50">
          <SubHeading>
            Whether you're an individual physician, a medical group, or a large
            hospital, we have the perfect plan to meet your medical education
            needs.
          </SubHeading>
        </Row>

        {/* <Row
          className="w-100 d-flex justify-content-center font-medium font-15 mb-50"
          style={{
            backgroundColor: "#fef9c3",
            padding: "12px",
            borderRadius: "7px",
            color: "#854d0e",
          }}
        >
          <Col>
            <strong>Development Mode:</strong> Using test Stripe keys. In
            production, replace the test variables in app/pricing/actions.ts
            with your actual Stripe API keys.
          </Col>
        </Row> */}

        <Row gutter={[24, 24]} className="w-100">
          {subscription.map((item) => (
            <Col lg={6} md={12} sm={24} xs={24}>
              <Card
                key={item.id}
                style={{
                  minHeight: "530px",
                  border: item.mostPopular ? "1px solid #8a3ef4" : null,
                  transform: item.mostPopular ? "scale(1.04)" : null,
                }}
              >
                {item.mostPopular && (
                  <div
                    style={{
                      position: "absolute",
                      top: -15,
                      left: 0,
                      right: 0,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      className="py-1"
                      style={{
                        backgroundColor: "#8a3ef4",
                        color: "#fff",
                        borderRadius: "20px",
                        fontWeight: "600",
                        padding: "10px",
                        fontSize: "12px",
                      }}
                    >
                      Most Popular
                    </div>
                  </div>
                )}
                <div
                  className="row-flex flex-column"
                  style={{ justifyContent: "space-between", minHeight: "480px" }}
                >
                  <div>
                    <div className="d-flex justify-content-center mt-5 mb-15">
                      <div
                        className="d-flex justify-content-center"
                        style={{
                          backgroundColor: "var(--border-color)",
                          padding: "12px",
                          borderRadius: "50%",
                          fontSize: "18px",
                        }}
                      >
                        {item?.icon}
                      </div>
                    </div>

                    <div className="d-flex justify-content-center font-20 font-bold mb-5 custom-primary-text">
                      {item.name}
                    </div>
                    <div
                      className="d-flex justify-content-center font-15 font-medium mb-5 custom-secondary-text"
                      style={{ textAlign: "center" }}
                    >
                      {item.description}
                    </div>
                    <div
                      className="d-flex justify-content-center font-bold mb-15 custom-primary-text"
                      style={{ fontSize: "30px" }}
                    >
                      {item?.price ? `$${item.price}` : "Call Us"}
                      <span className="font-19 font-semibold custom-primary-text">
                        {item?.billingLabel}
                      </span>
                    </div>
                    <div>
                      <ul className="p-0">
                        {item.features.map((x, index) => (
                          <li
                            key={index}
                            className="mb-5 font-medium font-15 d-flex justify-start"
                            style={{ gap: "5px", color: "#020817" }}
                          >
                            <FaCheck
                              style={{ color: "#8a3ef4", fontSize: "15px" }}
                            />{" "}
                            {x}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div>
                    <CustomButton
                      className="w-100"
                      onClick={() => {
                        if(item?.price) {

                          history.push(`/sign-up?plan=${item?.name?.toLowerCase()}`)}
                        else {
                          window.location.href = 'mailto:info@meducate.ai';
                        }
                      }}
                    >
                      {item?.price ? "Subscribe Now" : "Contact Us"}
                    </CustomButton>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
          {/* <Col>
            </Col>
            <Col>
            </Col> */}
        </Row>
      </PricingPageWrapper>
    </>
  );
};

export default PricingPage;
